import { Directive, OnChanges, SimpleChanges, Input, ElementRef } from '@angular/core';
import { DialogRef } from './dialog-ref';

/**
 * Button that will close the current dialog.
 */
@Directive({
    selector: 'button[payDialogClose]',
    standalone: true,
    host: {
        '(click)': 'close(payDialogClose)',
        'type': 'button'
    }
})
export class DialogCloseDirective {

    /** Dialog close input. */
    @Input() dialogResult: any;
    @Input() payDialogClose: any;

    constructor(public dialogRef: DialogRef<any>,
                public elementRef: ElementRef) { }


    /**
     * Emit the close status via the onClose method into the hosting component (dialog component)
     * @param val
     */
    close(val) {
        if (this.dialogRef?.componentInstance?.onClose) {
            this.dialogRef.componentInstance.onClose();
        }
        this.dialogRef.close(val);
    }
}
